import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./loading-initial";

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    onLoading(state) {
      state.isLoading = true;
    },
    loadingSuccess(state) {
      state.isLoading = false;
    },
  },
});

export const loadingActions = loadingSlice.actions;

export default loadingSlice.reducer;
